module.exports = __webpack_public_path__ + "static/media/1010243.94ddd23b.jpg";